/* eslint-disable */
import React from 'react';

class CSSVariableApplicator extends React.Component {
  componentDidMount() {
    const { variables } = this.props;
    this.updateCSSVariables(variables);
  }

  componentDidUpdate(prevProps) {
    const { variables } = this.props;
    if (variables !== prevProps.variables) {
      this.updateCSSVariables(variables);
    }
  }

  updateCSSVariables(variables) {
    Object.keys(variables).forEach(key => {
      document.documentElement.style.setProperty(key, variables[key]);
    });
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default CSSVariableApplicator;
